import { defineMessages } from 'react-intl';

export default defineMessages({
  isLoading: {
    id: 'field-service-app.product.loading',
    defaultMessage: 'Loading...',
  },
  isTakingTooLong: {
    id: 'connection.isTakingTooLong',
    defaultMessage: 'There might be an error',
  },
});
